export default __webpack_public_path__ + "static/media/measure.bd1a768d.png";